export default import.meta.ROLLUP_FILE_URL_laBw5JWpB5XuI0i4$Unjgw